var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CountDown',{attrs:{"countDownDate":_vm.countDownDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }